<template>
  <TemplateUnificado
    v-if="categoria.tipo_template === 'Template unificado'"
    :categoria
    class="mb-40"
  />

  <OTableServerSideBase
    v-else
    class="TableSolicitacoes mb-32"
    :columns="colsSolicitacoesArquivos"
    :api-url="`${URLS.solicitacoesArquivos}?grupo_arquivo__categoria_arquivo=${categoria.name}`"
  >
    <template #body="props">
      <TrSolicitacoesArquivos
        :props="props"
        @click="(grupo) => $emit('click', grupo, props)"
        @click:anexar="
          (grupo) => $emit('click:anexar', grupo, props)
        "
      />
    </template>
  </OTableServerSideBase>
</template>

<script setup>
import { URLS } from 'js/modules/axios'
import OTableServerSideBase from './OTableServerSideBase.vue'
import TemplateUnificado from 'components/Template/TemplateUnificado.vue'
import TrSolicitacoesArquivos from 'components/Tr/TrSolicitacoesArquivos.vue'

const { categoria, colsSolicitacoesArquivos } = defineProps({
  colsSolicitacoesArquivos: {
    type: Array,
    required: true,
  },
  categoria: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['click', 'click:anexar'])
</script>

<style lang="scss" scoped></style>
